import styled, { css } from "styled-components";
import ReactInputMask from "react-input-mask";
import designSystemColors from "../../styles";

const commonInput = css<{ error?: boolean }>`
  width: 100%;
  padding: 8px 12px;
  border-radius: 2px;
  border: ${({ error }) =>
    error
      ? css`1px solid ${designSystemColors.errorColor}`
      : css`1px solid ${designSystemColors.border.input};`};
  background: ${designSystemColors.background};

  font-size: 16px;
  outline: 0;
  caret-color: #5188f4;
  color: #434343;

  &:disabled {
    background: #ccc !important;
    opacity: 0.4;
    cursor: no-drop;

    &::placeholder {
      color: ${designSystemColors.textDark};
    }
  }

  &::placeholder {
    color: #bfbfbf;
    font-weight: 400;
  }
`;

export const CustomInput = styled.input<{ error?: boolean }>`
  ${commonInput}

  &[type="date"] {
    color: ${({ value }) =>
      value
        ? css`
            #434343
          `
        : css`#bfbfbf;`};
  }
`;

export const CustomReactInputMask = styled(ReactInputMask)`
  ${commonInput}
`;
